export const CHART_COLORS = [
  '#1f77b4',  // muted blue
  '#ff7f0e',  // safety orange
  '#2ca02c',  // cooked asparagus green
  '#d62728',  // brick red
  '#9467bd',  // muted purple
  '#8c564b',  // chestnut brown
  '#e377c2',  // raspberry yogurt pink
  '#7f7f7f',  // middle gray
  '#bcbd22',  // curry yellow-green
  '#17becf'   // blue-teal
  // '#6a3d9a',
  // '#fb9a99',
  // '#1f78b4',
  // '#cab2d6',
  // '#ffff99',
  // '#a6cee3',
  // '#e31a1c',
  // '#fdbf6f',
  // '#ff7f00',
  // '#33a02c',
  // '#b2df8a',
];


// WEBPACK FOOTER //
// ./src/utilities/colors.js